import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Global Selectors
// @ts-ignore
import { selectMultipleActiveTableRowsExist } from 'services/selectedTableCells/selectors';

interface OwnProps {
    children: React.ReactElement;
}

interface ConnectedProps {
    multipleActiveTableRowsExist?: boolean;
}

type Props = OwnProps & ConnectedProps;

export class MultipleActiveTableRowsExistGateComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { multipleActiveTableRowsExist, children } = this.props;
        if (!multipleActiveTableRowsExist) {
            return null;
        }
        return children;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    multipleActiveTableRowsExist: selectMultipleActiveTableRowsExist
});

export default connect(mapStateToProps)(
    MultipleActiveTableRowsExistGateComponent
);
